export const howItWorks = [
  {
    id: 0,
    heading: "Download the App",
    description: "Sign up, create a password, and then log in.",
    img: "/assets/landing-page/how-it-works/partners/individual-with-fleet/1.webp",
  },
  {
    id: 1,
    heading: "Driver Personal Details",
    description:
      "Complete the Profile Details ( First & Last Name, Email ID, Password, Contact Number, Address, Pincode & City )",
    img: "/assets/landing-page/how-it-works/partners/individual-with-fleet/2.webp",
  },
  {
    id: 2,
    heading: "Choose Vehicle Now",
    description:
      "1. Vehicle Name\n2.Vehicle Type(Three or Four Wheeler or Bike)\n3.Vehicle Number",
    img: "/assets/landing-page/how-it-works/partners/individual-with-fleet/3.webp",
  },
  {
    id: 3,
    heading: "Upload Required Documents",
    description:
      "Aadhar Card | PAN card | Driving License | RC book | Passport Size Photo.",
    img: "/assets/landing-page/how-it-works/partners/individual-with-fleet/1.webp",
  },
  {
    id: 4,
    heading: "Training & Instructions",
    description:
      "Complete the online training and the app using the instructions.",
    img: "/assets/landing-page/how-it-works/partners/individual-with-fleet/2.webp",
  },
  {
    id: 5,
    heading: "Collect your welcome kit",
    description: "",
    img: "/assets/landing-page/how-it-works/partners/individual-with-fleet/3.webp",
  },
  {
    id: 6,
    heading: "Easy to take orders",
    description: "Start accepting delivery orders.",
    img: "/assets/landing-page/how-it-works/partners/individual-with-fleet/1.webp",
  },
];

export const individualWithFleetHowItWorks = [
  {
    id: 0,
    heading: "Download the App",
    description: "Sign up, create a password, and then log in.",
    img: "/assets/landing-page/how-it-works/partners/individual-with-fleet/1.webp",
  },
  {
    id: 1,
    heading: "Driver Personal Details",
    description:
      "Complete the Profile Details ( First & Last Name, Email ID, Password, Contact Number, Address, Pincode & City )",
    img: "/assets/landing-page/how-it-works/partners/individual-with-fleet/2.webp",
  },
  {
    id: 2,
    heading: "Choose Vehicle Now",
    description:
      "1. Vehicle Name\n2.Vehicle Type(Three or Four Wheeler or Bike)\n3.Vehicle Number",
    img: "/assets/landing-page/how-it-works/partners/individual-with-fleet/3.webp",
  },
  {
    id: 3,
    heading: "Upload Required Documents",
    description:
      "Aadhar Card | PAN card | Driving License | RC book | Passport Size Photo.",
    img: "/assets/landing-page/how-it-works/partners/individual-with-fleet/1.webp",
  },
  {
    id: 4,
    heading: "Training & Instructions",
    description:
      "Complete the online training and the app using the instructions.",
    img: "/assets/landing-page/how-it-works/partners/individual-with-fleet/2.webp",
  },
  {
    id: 5,
    heading: "Collect your welcome kit",
    description: "",
    img: "/assets/landing-page/how-it-works/partners/individual-with-fleet/3.webp",
  },
  {
    id: 6,
    heading: "Easy to take orders",
    description: "Start accepting delivery orders.",
    img: "/assets/landing-page/how-it-works/partners/individual-with-fleet/1.webp",
  },
];

export const intraCityHowItWorks = [
  {
    id: 0,
    heading: "Book Like a Boss",
    description: "It's so easy, you might think you missed something. (You didn't - we just made it that simple!) Sign Up (Free!) & Place Order (Easily!) Simpler than making chai!",
    img: "/assets/landing-page/how-it-works/partners/individual-with-fleet/1.webp",
  },
  {
    id: 1,
    heading: "Meet Your Perfect Match",
    description: "Choose Vehicle: Like picking your favorite chutney! Our smart system plays matchmaker between your package and the perfect driver. It's like a dating app, but for deliveries!",
    img: "/assets/landing-page/how-it-works/partners/individual-with-fleet/2.webp",
  },
  {
    id: 2,
    heading: "Watch The Journey",
    description: "Track deliveries like you track your favorite cricket match - ball by ball (or in this case, turn by turn)!",
    img: "/assets/landing-page/how-it-works/partners/individual-with-fleet/3.webp",
  },
  {
    id: 3,
    heading: "Safe & Sound Delivery",
    description: "Our drivers handle packages more carefully than a diamond merchant handles his goods!",
    img: "/assets/landing-page/how-it-works/partners/individual-with-fleet/1.webp",
  },
  {
    id: 4,
    heading: "Smooth Payments",
    description: "Assured Prices unlike handling Law Garden vendors negotiation fuss and Pay your way –UPI , wallet, or business credit. Easy as pie, minus the calories!",
    img: "/assets/landing-page/how-it-works/partners/individual-with-fleet/2.webp",
  },
  {
    id: 5,
    heading: "Share The Love",
    description: "Rate your experience and help us keep the good times rolling. Your feedback is our favorite kind of homework!",
    img: "/assets/landing-page/how-it-works/partners/individual-with-fleet/3.webp",
  },
  // {
  //   id: 6,
  //   heading: "Tap ‘Check Prices’",
  //   description: "",
  //   img: "/assets/landing-page/how-it-works/partners/individual-with-fleet/1.webp",
  // },
  // {
  //   id: 7,
  //   heading: "Apply Coupon Code",
  //   description: "",
  //   img: "/assets/landing-page/how-it-works/partners/individual-with-fleet/1.webp",
  // },
  // {
  //   id: 8,
  //   heading:
  //     "Choose your payment method - Cash, To Pay, TapTap Wallet  or Digital Payment",
  //   description: "",
  //   img: "/assets/landing-page/how-it-works/partners/individual-with-fleet/1.webp",
  // },
  // {
  //   id: 9,
  //   heading: "Meet the driver and spend your package on its way.",
  //   description: "",
  //   img: "/assets/landing-page/how-it-works/partners/individual-with-fleet/1.webp",
  // },
  // {
  //   id: 10,
  //   heading: "You're all set. Track your order as we get it TapTap.",
  //   description: "",
  //   img: "/assets/landing-page/how-it-works/partners/individual-with-fleet/1.webp",
  // },
  // {
  //   id: 11,
  //   heading:
  //     "After your Delivery Customers give the review and rating for Delivery Partners.",
  //   description: "",
  //   img: "/assets/landing-page/how-it-works/partners/individual-with-fleet/1.webp",
  // },
];

// const spanLabel = (label: string) => `<span class="fw-500 text-center">${label}</span>`;

export const partLoadAndFullLoadHowItWorks = [
  {
    id: 0,
    heading: "Post Like a Pro",
    description: `It’s as simple as posting a selfie on social media! Use our web or mobile app to post your intercity part load shipment details. No stress, no fuss – just a few taps and you’re done!`,
    img: "/assets/landing-page/how-it-works/partners/individual-with-fleet/1.webp",
  },
  {
    id: 1,
    heading: "Bid Bonanza",
    description: `Transporters bid on your shipment, giving you a marketplace of options. It’s like haggling at a flea market, but without the sweat – you just sit back and pick the best deal!`,
    img: "/assets/landing-page/how-it-works/partners/individual-with-fleet/2.webp",
  },
  {
    id: 2,
    heading: "Choose Your Champion",
    description: `Select the transporter that fits your needs and budget like a glove. You’re the boss here – no compromises, just the perfect match for your shipment.`,
    img: "/assets/landing-page/how-it-works/partners/individual-with-fleet/3.webp",
  },
  {
    id: 3,
    heading: "Unpack the Mystery",
    description: `Track your shipment's progress in real-time, turn by turn. It's like having a clear window into your supply chain – no more wondering, just transparent updates from start to finish!`,
    img: "/assets/landing-page/how-it-works/partners/individual-with-fleet/1.webp",
  },
  {
    id: 4,
    heading: "Smooth Sailing Delivery & payment",
    description: `Your goods arrive without a hitch, just like a calm sea voyage. Relax and enjoy the peace of mind – we'll take care of the rest.`,
    img: "/assets/landing-page/how-it-works/partners/individual-with-fleet/2.webp",
  },
  {
    id: 5,
    heading: "Spread the Love",
    description: `Rate your experience and help us keep the magic alive. Your feedback is our secret sauce – and we’re always hungry for more!`,
    img: "/assets/landing-page/how-it-works/partners/individual-with-fleet/2.webp",
  },
];

export const expressParcelBranchToBranchHowItWorks = [
  {
    id: 0,
    heading: "Booking",
    description: "Book through our website, or app, or visit any of our 70+ branches.",
    img: "/assets/landing-page/how-it-works/partners/individual-with-fleet/1.webp",
  },
  {
    id: 1,
    heading: "Pickup",
    description: "Choose door collection or godown drop-off.",
    img: "/assets/landing-page/how-it-works/partners/individual-with-fleet/2.webp",
  },
  {
    id: 2,
    heading: "Transport",
    description: "Secure transport across 24 states using company-owned vehicles.",
    img: "/assets/landing-page/how-it-works/partners/individual-with-fleet/3.webp",
  },
  {
    id: 3,
    heading: "Tracking",
    description: "Real-time tracking is available online.",
    img: "/assets/landing-page/how-it-works/partners/individual-with-fleet/1.webp",
  },
  {
    id: 4,
    heading: "Billing",
    description: "Seamless billing and payment options.",
    img: "/assets/landing-page/how-it-works/partners/individual-with-fleet/2.webp",
  }
];

export const expressParcelDoorDeliveryHowItWorks = [
  {
    id: 0,
    heading: "Create a Shipment",
    description: "Upload bulk shipments or create them manually through the TapTap dashboard.",
    img: "/assets/landing-page/how-it-works/partners/individual-with-fleet/1.webp",
  },
  {
    id: 1,
    heading: "Order Placement",
    description: "Customers place orders for document or package pickup via our website or app.",
    img: "/assets/landing-page/how-it-works/partners/individual-with-fleet/2.webp",
  },
  {
    id: 2,
    heading: "Select a courier partner",
    description: "Choose a courier partner with our AI tool, based on factors such as weight, destination, and more.",
    img: "/assets/landing-page/how-it-works/partners/individual-with-fleet/3.webp",
  },
  {
    id: 3,
    heading: "Transportation",
    description: "Packages are securely transported to our sorting facility for efficient routing.",
    img: "/assets/landing-page/how-it-works/partners/individual-with-fleet/1.webp",
  },
  {
    id: 4,
    heading: "Ship your parcel",
    description: "Generate labels, prepare your packages, and hand them over to the chosen courier partner.",
    img: "/assets/landing-page/how-it-works/partners/individual-with-fleet/2.webp",
  },
  {
    id: 5,
    heading: "Delivery",
    description: "We ensure timely delivery to the recipient's doorstep, providing real-time tracking and updates.",
    img: "/assets/landing-page/how-it-works/partners/individual-with-fleet/2.webp",
  },
  {
    id: 6,
    heading: "Confirmation",
    description: "Once delivered, customers receive confirmation of successful delivery.",
    img: "/assets/landing-page/how-it-works/partners/individual-with-fleet/2.webp",
  },
];

export const howItWorksData = [
  {
    id: 0,
    page: "partners",
    partner: "Individual With Fleet",
    howItWorks: individualWithFleetHowItWorks,
  },
  {
    id: 1,
    page: "services",
    service: "Intracity",
    howItWorks: intraCityHowItWorks,
  },
  {
    id: 2,
    page: "services",
    service: "Part Load & Full Load",
    howItWorks: partLoadAndFullLoadHowItWorks,
  },
  {
    id: 3,
    page: "services",
    service: "Intercity Express Parcel",
    expressParcelType: "Branch to Branch",
    howItWorks: expressParcelBranchToBranchHowItWorks,
  },
  {
    id: 4,
    page: "services",
    service: "Intercity Express Parcel",
    expressParcelType: "Door Delivery",
    howItWorks: expressParcelDoorDeliveryHowItWorks,
  },
];
